module.exports = __webpack_public_path__ + "img/TOB-1.172bc30a.png";